import { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'outline' | 'success' | 'danger';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  /**
   * Accion que dispara la tecla Enter dentro del `Modal` (con confirmacion; Ctrl/Cmd+Enter sin
   * confirmacion). Una sola por modal; nunca en acciones destructivas.
   */
  enterAction?: boolean;
};

const variantClass: Record<Variant, string> = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  outline: 'btn-outline',
  success: 'btn-success',
  danger: 'btn-danger',
};

export function Button({ variant = 'primary', className, enterAction, ...props }: Props) {
  return (
    <button
      className={['btn', variantClass[variant], className].filter(Boolean).join(' ')}
      data-enter-action={enterAction ? '' : undefined}
      {...props}
    />
  );
}
